import { useLocation } from "react-router-dom";
import { useState } from "react";
import { isMobile } from "@/helpers/utils";
import { BaseContainer } from "@/pages/authentication/components/base";
import { Alert, AlertDescription, AlertTitle, Typography } from "@altimateai/lego";
import { IconCircleCheckFilled } from "@tabler/icons-react";
import { getRoutingComponent } from "supertokens-auth-react/ui";
import { ThirdPartyPreBuiltUI } from "supertokens-auth-react/recipe/thirdparty/prebuiltui";

export const SuperTokenLogin = () => {
  const { state } = useLocation();
  const [expired] = useState(state?.expired);
  const [message] = useState("");

  const isMobileView = isMobile();

  return (
    <BaseContainer>
      <div className={isMobileView ? "al-w-[90vw]" : ""}>
        {message && (
          <Alert variant="success" className="al-my-2">
            <IconCircleCheckFilled />
            <AlertTitle className={"al-text-base"}>Success</AlertTitle>
            <AlertDescription>{message}</AlertDescription>
          </Alert>
        )}
        {/* <Header>Sign In</Header> */}
        {expired && (
          <Typography variant={"caption"} className="al-text-muted-foreground">
            Session expired. Please login again.
          </Typography>
        )}
        {getRoutingComponent([ThirdPartyPreBuiltUI])}
      </div>
    </BaseContainer>
  );
};
